module.exports = __webpack_public_path__ + "static/media/img-axum-product-4@3x.0723dbb5.png";